// Profile → Plan: the account's subscription periods, latest first.
import { useTranslation } from 'react-i18next';
import type { BillingPeriod } from './billing';
import own from './SubscribeDialog.module.css';

export function PlanHistory({ history }: { history: BillingPeriod[] }) {
  const { t, i18n } = useTranslation();
  if (history.length === 0) return null;
  const date = (iso: string) =>
    new Date(iso).toLocaleDateString(i18n.language, { day: 'numeric', month: 'short', year: 'numeric' });

  return (
    <details className={own.history}>
      <summary>{t('subscribe.history.title', { count: history.length })}</summary>
      <ul>
        {history.map((period, index) => (
          <li key={`${period.startDate}-${index}`} className={own.period}>
            <span className={own.periodType}>{period.type || t('subscribe.history.subscription')}</span>
            <span className={own.periodDates}>
              {t('subscribe.history.dates', { from: date(period.startDate), to: date(period.endDate) })}
            </span>
            {period.active && <span className={own.periodActive}>{t('subscribe.history.active')}</span>}
          </li>
        ))}
      </ul>
    </details>
  );
}
